/**
 * Monero daemon connection span.
 */
export default class MoneroConnectionSpan {
    constructor(span) {
        Object.assign(this, span);
    }
    toJson() {
        return Object.assign({}, this);
    }
    getConnectionId() {
        return this.connectionId;
    }
    setConnectionId(connectionId) {
        this.connectionId = connectionId;
        return this;
    }
    getNumBlocks() {
        return this.numBlocks;
    }
    setNumBlocks(numBlocks) {
        this.numBlocks = numBlocks;
        return this;
    }
    getRemoteAddress() {
        return this.remoteAddress;
    }
    setRemoteAddress(remoteAddress) {
        this.remoteAddress = remoteAddress;
        return this;
    }
    getRate() {
        return this.rate;
    }
    setRate(rate) {
        this.rate = rate;
        return this;
    }
    getSpeed() {
        return this.speed;
    }
    setSpeed(speed) {
        this.speed = speed;
        return this;
    }
    getSize() {
        return this.size;
    }
    setSize(size) {
        this.size = size;
        return this;
    }
    getStartHeight() {
        return this.startHeight;
    }
    setStartHeight(startHeight) {
        this.startHeight = startHeight;
        return this;
    }
}
